module.exports = __webpack_public_path__ + "static/media/Ether Window Playstore.e2a0cd33.png";